import { Component, OnDestroy } from '@angular/core';
import { FormControl, Validators } from '@angular/forms';
import { ActivatedRoute, Router } from '@angular/router';
import { CategoryInterface, OrganisationInterface } from '@careapp/angular-sdk';
import { Store } from '@ngrx/store';
import { Observable, Subscription } from 'rxjs';

import { FormMode } from '../../shared/constants';
import * as actions from '../../store/actions/index';
import * as selectors from '../../store/reducers/index';
import { ORGANISATION_ROLES } from '@careapp/core';

@Component({
  selector: 'admin-organisation',
  templateUrl: './organisation.component.html',
  styleUrls: ['./organisation.component.scss']
})
export class AdminOrganisationComponent implements OnDestroy {
  roles = ORGANISATION_ROLES;
  formMode = FormMode.EDIT;
  category = new FormControl('', Validators.required);
  organisation: Observable<OrganisationInterface>;
  loading: Observable<boolean>;
  sent: Observable<boolean>;
  error: Observable<string>;
  categories$: Observable<CategoryInterface[]>;
  allCategories$: Observable<CategoryInterface[]>;

  private subs = new Array<Subscription>();
  private orgId: string;

  constructor(private route: ActivatedRoute, private router: Router, private store: Store<any>) {
    this.organisation = this.store.select(selectors.getSelected(selectors.ORGANISATIONS));
    this.subs.push(this.route.params.subscribe(params => this.setOrganisation(params)));
    this.loading = this.store.select(selectors.invite.getLoading);
    this.sent = this.store.select(selectors.invite.getSent);
    this.error = this.store.select(selectors.invite.getError);
    this.categories$ = this.store.select(selectors.getCurrentOrganisationCategories);
    this.allCategories$ = this.store.select(selectors.getAll(selectors.MEMO_CATEGORIES));
  }

  ngOnDestroy() {
    for (const sub of this.subs) {
      sub.unsubscribe();
    }
  }

  setOrganisation(params) {
    this.orgId = params.id;
    this.store.dispatch(new actions.RequestInvitationResetAction());
    this.store.dispatch(actions.Organisations.SelectByIdAction({ id: params.id }));
    this.store.dispatch(actions.Organisations.RequestByIdAction({ id: params.id }));
    this.store.dispatch(actions.MemoCategories.RequestAllAction);
    this.store.dispatch(actions.MemoCategories.RequestByIdAction({ id: params.id }));
  }

  saveOrganisation(data) {
    this.store.dispatch(actions.Organisations.RequestSaveAction({ id: this.orgId, data }));
  }

  invite(payload) {
    this.store.dispatch(new actions.RequestInvitationSendAction(payload));
  }

  resetInvite() {
    this.store.dispatch(new actions.RequestInvitationResetAction());
  }

  removeCategory($event) {
    this.store.dispatch(actions.MemoCategories.RequestRemoveById({ id: $event.id }));
  }

  renderCategory(item: CategoryInterface) {
    return item ? item.name : '';
  }

  saveCategory(event: any) {
    this.store.dispatch(
      actions.MemoCategories.RequestAddById({ ...event.row, ordinal: event.ordinal })
    );
  }

  filterCategory(search: string, item: CategoryInterface) {
    if (!search || !search.toLowerCase) {
      return true;
    }
    return item.name.toLowerCase().startsWith(search.toLowerCase());
  }

  addCategory() {
    if (this.category.valid) {
      this.store.dispatch(actions.MemoCategories.RequestAddById(this.category.value));
      this.category.reset();
    }
  }
}
